import { render, staticRenderFns } from "./doorConfig.vue?vue&type=template&id=071bfaf4&"
import script from "./doorConfig.vue?vue&type=script&lang=js&"
export * from "./doorConfig.vue?vue&type=script&lang=js&"
import style0 from "./doorConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports